/* eslint-disable no-unused-vars */

import i18n from "i18n";
import keys from "locale/keys";

import { ROUTES } from "./constants";

// ==========================================
// 1. MARKETPLACE (Lucid/Supplier Routing)
// ==========================================

export enum MarketplaceCode {
  ERROR = -1,
  IN_SCREENER = 1,
  IN_CLIENT_SURVEY = 3,
  TERM_INDUSTRY_LOCKOUT = 21,
  TERM_STANDARD_QUALIFICATION = 23,
  TERM_CUSTOM_QUALIFICATION = 24,
  QUALITY_TERM_UNIQUE_IP = 30,
  QUALITY_TERM_INVALID_TRAFFIC = 32,
  QUALITY_TERM_SUPPLIER_PID_DUPLICATE = 35,
  QUALITY_TERM_COOKIE_DUPLICATE = 36,
  QUALITY_TERM_GEO_IP_MISMATCH = 37,
  OVERQUOTA_QUOTA_FULL = 40,
  OVERQUOTA_SUPPLIER_ALLOCATION = 41,
  OVERQUOTA_SURVEY_CLOSED_FOR_ENTRY = 42,
  FINANCIAL_TERM_CPI_BELOW_RATE_CARD = 50,
  EXIT_END_OF_ROUTER = 98,
  TERM_PRE_CLIENT_SURVEY_OPT_OUT = 120,
  TERM_RETURN_TO_MARKETPLACE_OPT_OUT = 122,
  TERM_MAX_CLIENT_SURVEY_ENTRIES = 123,
  TERM_MAX_TIME_IN_ROUTER = 124,
  TERM_MAX_TIME_IN_ROUTER_WARNING_OPT_OUT = 125,
  TERM_MAX_ANSWER_LIMIT = 126,
  QUALITY_TERM_SUPPLIER_ENCRYPTION_FAILURE = 131,
  QUALITY_TERM_BLOCKED_PANELIST_ID = 132,
  QUALITY_TERM_BLOCKED_IP = 133,
  QUALITY_TERM_MAX_COMPLETES_PER_DAY = 134,
  QUALITY_TERM_SURVEY_GROUP_COOKIE_DUPLICATE = 138,
  QUALITY_TERM_SURVEY_GROUP_SUPPLIER_PID_DUPLICATE = 139,
  QUALITY_TERM_SURVEY_GROUP_UNIQUE_IP = 230,
  OFAC_TERM_BLOCKED_COUNTRY_IP = 234,
  PRIVACY_TERM_NO_PRIVACY_CONSENT = 236,
  PRIVACY_TERM_MINIMUM_AGE = 237,
  QUALITY_TERM_FOUND_ON_DENY_LIST = 238,
  QUALITY_TERM_INVALID_BROWSER = 240,
  QUALITY_TERM_RESPONDENT_THRESHOLD_LIMIT = 241,
  QUALITY_TERM_RESPONDENT_QUALITY_SCORE = 242,
  QUALITY_TERM_MARKETPLACE_SIGNATURE_CHECK = 243,
  TERM_CONCURRENT_SESSION_ATTEMPT = 301,
  TERM_SESSION_COOKIE_EXPIRED = 302,
  TERM_SESSION_TIMEOUT = 303,
}

const DEFAULT_ERROR_MSG =
  "An error has occurred.\nPlease try selecting another survey to continue.";
const GEO_IP_MISMATCH_MSG =
  "An error has occurred.\nIt looks like you’re accessing this survey from a country that isn’t eligible.";

export const MarketplaceMessages: Record<MarketplaceCode, string> = {
  [MarketplaceCode.ERROR]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.IN_SCREENER]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.IN_CLIENT_SURVEY]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_INDUSTRY_LOCKOUT]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_STANDARD_QUALIFICATION]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_CUSTOM_QUALIFICATION]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_UNIQUE_IP]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_INVALID_TRAFFIC]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_SUPPLIER_PID_DUPLICATE]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_COOKIE_DUPLICATE]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_GEO_IP_MISMATCH]: GEO_IP_MISMATCH_MSG,
  [MarketplaceCode.OVERQUOTA_QUOTA_FULL]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.OVERQUOTA_SUPPLIER_ALLOCATION]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.OVERQUOTA_SURVEY_CLOSED_FOR_ENTRY]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.FINANCIAL_TERM_CPI_BELOW_RATE_CARD]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.EXIT_END_OF_ROUTER]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_PRE_CLIENT_SURVEY_OPT_OUT]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_RETURN_TO_MARKETPLACE_OPT_OUT]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_MAX_CLIENT_SURVEY_ENTRIES]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_MAX_TIME_IN_ROUTER]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_MAX_TIME_IN_ROUTER_WARNING_OPT_OUT]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_MAX_ANSWER_LIMIT]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_SUPPLIER_ENCRYPTION_FAILURE]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_BLOCKED_PANELIST_ID]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_BLOCKED_IP]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_MAX_COMPLETES_PER_DAY]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_SURVEY_GROUP_COOKIE_DUPLICATE]:
    DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_SURVEY_GROUP_SUPPLIER_PID_DUPLICATE]:
    DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_SURVEY_GROUP_UNIQUE_IP]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.OFAC_TERM_BLOCKED_COUNTRY_IP]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.PRIVACY_TERM_NO_PRIVACY_CONSENT]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.PRIVACY_TERM_MINIMUM_AGE]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_FOUND_ON_DENY_LIST]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_INVALID_BROWSER]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_RESPONDENT_THRESHOLD_LIMIT]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_RESPONDENT_QUALITY_SCORE]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.QUALITY_TERM_MARKETPLACE_SIGNATURE_CHECK]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_CONCURRENT_SESSION_ATTEMPT]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_SESSION_COOKIE_EXPIRED]: DEFAULT_ERROR_MSG,
  [MarketplaceCode.TERM_SESSION_TIMEOUT]: DEFAULT_ERROR_MSG,
};

// ==========================================
// 2. CLIENT (Return from Survey)
// ==========================================

export enum ClientCode {
  NEVER_REACHED_CLIENT = -1,
  IN_CLIENT_SURVEY = 1,
  COMPLETED = 10,
  COMPLETED_ADJUSTED = 11,
  TERM_RETURNED_AS_TERMINATE = 20,
  TERM_ADJUSTED_TO_TERMINATE_COMPLETES = 26,
  TERM_ADJUSTED_TO_TERMINATE_POST_SURVEY = 28,
  QUALITY_TERM_RETURNED_AS_QUALITY_TERM = 30,
  QUALITY_TERM_SPEEDER = 33,
  QUALITY_TERM_OPEN_END = 34,
  QUALITY_TERM_ENCRYPTION_FAILURE = 35,
  QUALITY_TERM_ADJUSTED_TO_TERMINATE_DISQUAL = 38,
  OVERQUOTA_CLIENT_SURVEY_QUOTA_FULL = 40,
  INTERMEDIARY_REJECTION_BY_SYSTEM = 60,
  INTERMEDIARY_REJECTION_BY_USER_DECLINED = 62,
  INTERMEDIARY_REJECTION_BY_USER_UNAUTHORIZED = 66,
  AUDIENCE_COMPLETE = 70,
  AUDIENCE_TERM = 80,
  REDIRECT_FAILURE_INCORRECT_FORMAT = 91,
  OPT_IN_SPECIFIC_STUDIES = 110,
  QUALITY_TERM_ENCRYPTION_FAILURE_CLIENT_SURVEY = 134,
  QUALITY_TERM_ENCRYPTION_FAILURE_MARKETPLACE_RETURN = 135,
  QUALITY_TERM_SURVEY_CLOSED = 136,
  QUALITY_TERM_VERIFY_CALLBACK_FAILURE = 137,
  QUALITY_TERM_INVALID_CLIENT_RESPONSE_STATUS = 233,
  QUALITY_TERM_SECURE_CLIENT_CALLBACK_FAILURE = 235,
  QUALITY_TERM_SERVER_TO_SERVER_CALLBACK_FAILURE = 335,
}

const SUCCESS_MSG =
  "Survey Completed Successfully\nThank you for participating! Your points will updated shortly.";

export const ClientMessages: Record<ClientCode, string> = {
  [ClientCode.NEVER_REACHED_CLIENT]: DEFAULT_ERROR_MSG,
  [ClientCode.IN_CLIENT_SURVEY]: DEFAULT_ERROR_MSG,
  [ClientCode.COMPLETED]: SUCCESS_MSG,
  [ClientCode.COMPLETED_ADJUSTED]: SUCCESS_MSG,
  [ClientCode.TERM_RETURNED_AS_TERMINATE]: DEFAULT_ERROR_MSG,
  [ClientCode.TERM_ADJUSTED_TO_TERMINATE_COMPLETES]: DEFAULT_ERROR_MSG,
  [ClientCode.TERM_ADJUSTED_TO_TERMINATE_POST_SURVEY]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_RETURNED_AS_QUALITY_TERM]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_SPEEDER]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_OPEN_END]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_ENCRYPTION_FAILURE]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_ADJUSTED_TO_TERMINATE_DISQUAL]: DEFAULT_ERROR_MSG,
  [ClientCode.OVERQUOTA_CLIENT_SURVEY_QUOTA_FULL]: DEFAULT_ERROR_MSG,
  [ClientCode.INTERMEDIARY_REJECTION_BY_SYSTEM]: DEFAULT_ERROR_MSG,
  [ClientCode.INTERMEDIARY_REJECTION_BY_USER_DECLINED]: DEFAULT_ERROR_MSG,
  [ClientCode.INTERMEDIARY_REJECTION_BY_USER_UNAUTHORIZED]: DEFAULT_ERROR_MSG,
  [ClientCode.AUDIENCE_COMPLETE]: SUCCESS_MSG,
  [ClientCode.AUDIENCE_TERM]: DEFAULT_ERROR_MSG,
  [ClientCode.REDIRECT_FAILURE_INCORRECT_FORMAT]: DEFAULT_ERROR_MSG,
  [ClientCode.OPT_IN_SPECIFIC_STUDIES]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_ENCRYPTION_FAILURE_CLIENT_SURVEY]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_ENCRYPTION_FAILURE_MARKETPLACE_RETURN]:
    DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_SURVEY_CLOSED]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_VERIFY_CALLBACK_FAILURE]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_INVALID_CLIENT_RESPONSE_STATUS]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_SECURE_CLIENT_CALLBACK_FAILURE]: DEFAULT_ERROR_MSG,
  [ClientCode.QUALITY_TERM_SERVER_TO_SERVER_CALLBACK_FAILURE]:
    DEFAULT_ERROR_MSG,
};

export const TOLUNA_MESSAGES = {
  [ROUTES.TOLUNA_QUALIFIED]: i18n.t(keys.toluna_qualified),
  [ROUTES.TOLUNA_NOT_QUALIFIED]: i18n.t(keys.toluna_not_qualified),
  [ROUTES.TOLUNA_QUOTA_FULL]: i18n.t(keys.toluna_quota_full),
  [ROUTES.TOLUNA_FRAUD_TERMINATE]: i18n.t(keys.toluna_fraud_terminate),
  [ROUTES.TOLUNA_TERMINATED]: i18n.t(keys.toluna_terminated),
  [ROUTES.TOLUNA_MAX_SURVEYS_REACHED]: i18n.t(keys.toluna_max_surveys_reached),
  [ROUTES.TOLUNA_NO_SURVEYS]: i18n.t(keys.toluna_no_surveys),
  [ROUTES.TOLUNA_NO_COOKIES]: i18n.t(keys.toluna_no_cookies),
  [ROUTES.TOLUNA_SURVEY_NOT_AVAILABLE]: i18n.t(
    keys.toluna_survey_not_available,
  ),
  [ROUTES.TOLUNA_SURVEY_TAKEN]: i18n.t(keys.toluna_survey_taken),
};
